let navbarModule = angular.module('app.pages.navbar', []);

navbarModule.directive('topNavbar', () => {
  return {
    restrict: 'E',
    scope: {},
    template: require('./top-navbar.html'),
    controller: require('./top-navbar.js').default,
    controllerAs: 'vm',
    bindToController: true,
  };
});

navbarModule.directive('leftNavbar', () => {
  return {
    restrict: 'E',
    template: require('./left-navbar.html'),
    controller: require('./left-navbar.js').default,
    controllerAs: 'vm',
    bindToController: true,
  };
});

export default navbarModule;



// WEBPACK FOOTER //
// ./app/pages/navbar/_index.js